var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React, { PureComponent } from 'react';
import ConsentManagerBuilder from '../consent-manager-builder';
import Container from './container';
import { ADVERTISING_CATEGORIES, FUNCTIONAL_CATEGORIES } from './categories';
var zeroValuePreferences = {
  marketingAndAnalytics: null,
  advertising: null,
  functional: null
};
var defaultPreferencesDialogTemplate = {
  headings: {
    allowValue: 'Allow',
    categoryValue: 'Category',
    purposeValue: 'Purpose',
    toolsValue: 'Tools'
  },
  checkboxes: {
    noValue: 'No',
    yesValue: 'Yes'
  },
  actionButtons: {
    cancelValue: 'Cancel',
    saveValue: 'Save'
  },
  cancelDialogButtons: {
    cancelValue: 'Yes, Cancel',
    backValue: 'Go Back'
  },
  categories: [{
    key: 'functional',
    name: 'Functional',
    description: 'To monitor the performance of our site and to enhance your browsing experience.',
    example: 'For example, these tools enable you to communicate with us via live chat.'
  }, {
    key: 'marketing',
    name: 'Marketing and Analytics',
    description: 'To understand user behavior in order to provide you with a more relevant browsing experience or personalize the content on our site.',
    example: 'For example, we collect information about which pages you visit to help us present more relevant information.'
  }, {
    key: 'advertising',
    name: 'Advertising',
    description: 'To personalize and measure the effectiveness of advertising on our site and other websites.',
    example: 'For example, we may serve you a personalized ad based on the pages you visit on our site.'
  }, {
    key: 'essential',
    name: 'Essential',
    description: 'We use browser cookies that are necessary for the site to work as intended.',
    example: 'For example, we store your website data collection preferences so we can honor them if you return to our site. You can disable these cookies in your browser settings but if you do the site may not work as intended.'
  }]
};
var ConsentManager = /** @class */function (_super) {
  __extends(ConsentManager, _super);
  function ConsentManager() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.mergeTemplates = function (newProps, defaultPreferencesDialogTemplate) {
      var headingsMerge = __assign(__assign({}, defaultPreferencesDialogTemplate.headings), newProps.headings);
      var checkboxesMerge = __assign(__assign({}, defaultPreferencesDialogTemplate.checkboxes), newProps.checkboxes);
      var actionButtonsMerge = __assign(__assign({}, defaultPreferencesDialogTemplate.actionButtons), newProps.actionButtons);
      var cancelDialogButtonsMerge = __assign(__assign({}, defaultPreferencesDialogTemplate.cancelDialogButtons), newProps.cancelDialogButtons);
      var categoriesMerge = defaultPreferencesDialogTemplate === null || defaultPreferencesDialogTemplate === void 0 ? void 0 : defaultPreferencesDialogTemplate.categories.map(function (category) {
        var _a;
        return __assign(__assign({}, category), (_a = newProps === null || newProps === void 0 ? void 0 : newProps.categories) === null || _a === void 0 ? void 0 : _a.find(function (c) {
          return c.key === category.key;
        }));
      });
      return {
        headings: headingsMerge,
        checkboxes: checkboxesMerge,
        actionButtons: actionButtonsMerge,
        cancelDialogButtons: cancelDialogButtonsMerge,
        categories: categoriesMerge
      };
    };
    _this.getInitialPreferences = function () {
      var _a = _this.props,
        initialPreferences = _a.initialPreferences,
        customCategories = _a.customCategories;
      if (initialPreferences) {
        return initialPreferences;
      }
      if (!customCategories) {
        return zeroValuePreferences;
      }
      var initialCustomPreferences = {};
      Object.keys(customCategories).forEach(function (category) {
        initialCustomPreferences[category] = null;
      });
      return initialCustomPreferences;
    };
    _this.handleMapCustomPreferences = function (destinations, preferences) {
      var customCategories = _this.props.customCategories;
      var destinationPreferences = {};
      var customPreferences = {};
      if (customCategories) {
        for (var _i = 0, _a = Object.keys(customCategories); _i < _a.length; _i++) {
          var preferenceName = _a[_i];
          var value = preferences[preferenceName];
          if (typeof value === 'boolean') {
            customPreferences[preferenceName] = value;
          } else {
            customPreferences[preferenceName] = true;
          }
        }
        destinations.forEach(function (destination) {
          // Mark custom categories
          Object.entries(customCategories).forEach(function (_a) {
            var categoryName = _a[0],
              integrations = _a[1].integrations;
            var consentAlreadySetToFalse = destinationPreferences[destination.id] === false;
            var shouldSetConsent = integrations.includes(destination.id);
            if (shouldSetConsent && !consentAlreadySetToFalse) {
              destinationPreferences[destination.id] = customPreferences[categoryName];
            }
          });
        });
        return {
          destinationPreferences: destinationPreferences,
          customPreferences: customPreferences
        };
      }
      // Default unset preferences to true (for implicit consent)
      for (var _b = 0, _c = Object.keys(preferences); _b < _c.length; _b++) {
        var preferenceName = _c[_b];
        var value = preferences[preferenceName];
        if (typeof value === 'boolean') {
          customPreferences[preferenceName] = value;
        } else {
          customPreferences[preferenceName] = true;
        }
      }
      var customPrefs = customPreferences;
      var _loop_1 = function (destination) {
        // Mark advertising destinations
        if (ADVERTISING_CATEGORIES.find(function (c) {
          return c === destination.category;
        }) && destinationPreferences[destination.id] !== false) {
          destinationPreferences[destination.id] = customPrefs.advertising;
        }
        // Mark function destinations
        if (FUNCTIONAL_CATEGORIES.find(function (c) {
          return c === destination.category;
        }) && destinationPreferences[destination.id] !== false) {
          destinationPreferences[destination.id] = customPrefs.functional;
        }
        // Fallback to marketing
        if (!(destination.id in destinationPreferences)) {
          destinationPreferences[destination.id] = customPrefs.marketingAndAnalytics;
        }
      };
      for (var _d = 0, destinations_1 = destinations; _d < destinations_1.length; _d++) {
        var destination = destinations_1[_d];
        _loop_1(destination);
      }
      return {
        destinationPreferences: destinationPreferences,
        customPreferences: customPreferences
      };
    };
    return _this;
  }
  ConsentManager.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      writeKey = _a.writeKey,
      otherWriteKeys = _a.otherWriteKeys,
      shouldRequireConsent = _a.shouldRequireConsent,
      implyConsentOnInteraction = _a.implyConsentOnInteraction,
      cookieDomain = _a.cookieDomain,
      cookieName = _a.cookieName,
      cookieExpires = _a.cookieExpires,
      cookieAttributes = _a.cookieAttributes,
      bannerContent = _a.bannerContent,
      bannerActionsBlock = _a.bannerActionsBlock,
      bannerSubContent = _a.bannerSubContent,
      bannerTextColor = _a.bannerTextColor,
      bannerBackgroundColor = _a.bannerBackgroundColor,
      bannerHideCloseButton = _a.bannerHideCloseButton,
      bannerAsModal = _a.bannerAsModal,
      preferencesDialogTitle = _a.preferencesDialogTitle,
      preferencesDialogContent = _a.preferencesDialogContent,
      cancelDialogTitle = _a.cancelDialogTitle,
      cancelDialogContent = _a.cancelDialogContent,
      customCategories = _a.customCategories,
      defaultDestinationBehavior = _a.defaultDestinationBehavior,
      cdnHost = _a.cdnHost,
      preferencesDialogTemplate = _a.preferencesDialogTemplate,
      onError = _a.onError;
    return React.createElement(ConsentManagerBuilder, {
      onError: onError,
      writeKey: writeKey,
      otherWriteKeys: otherWriteKeys,
      shouldRequireConsent: shouldRequireConsent,
      cookieDomain: cookieDomain,
      cookieName: cookieName,
      cookieExpires: cookieExpires,
      cookieAttributes: cookieAttributes,
      initialPreferences: this.getInitialPreferences(),
      mapCustomPreferences: this.handleMapCustomPreferences,
      customCategories: customCategories,
      defaultDestinationBehavior: defaultDestinationBehavior,
      cdnHost: cdnHost
    }, function (_a) {
      var destinations = _a.destinations,
        customCategories = _a.customCategories,
        newDestinations = _a.newDestinations,
        preferences = _a.preferences,
        isConsentRequired = _a.isConsentRequired,
        setPreferences = _a.setPreferences,
        resetPreferences = _a.resetPreferences,
        saveConsent = _a.saveConsent,
        havePreferencesChanged = _a.havePreferencesChanged,
        workspaceAddedNewDestinations = _a.workspaceAddedNewDestinations;
      return React.createElement(Container, {
        customCategories: customCategories,
        destinations: destinations,
        newDestinations: newDestinations,
        preferences: preferences,
        isConsentRequired: isConsentRequired,
        setPreferences: setPreferences,
        resetPreferences: resetPreferences,
        saveConsent: saveConsent,
        closeBehavior: _this.props.closeBehavior,
        implyConsentOnInteraction: implyConsentOnInteraction !== null && implyConsentOnInteraction !== void 0 ? implyConsentOnInteraction : ConsentManager.defaultProps.implyConsentOnInteraction,
        bannerContent: bannerContent,
        bannerSubContent: bannerSubContent,
        bannerActionsBlock: bannerActionsBlock,
        bannerHideCloseButton: bannerHideCloseButton,
        bannerTextColor: bannerTextColor || ConsentManager.defaultProps.bannerTextColor,
        bannerBackgroundColor: bannerBackgroundColor || ConsentManager.defaultProps.bannerBackgroundColor,
        bannerAsModal: bannerAsModal,
        preferencesDialogTitle: preferencesDialogTitle,
        preferencesDialogContent: preferencesDialogContent,
        cancelDialogTitle: cancelDialogTitle,
        cancelDialogContent: cancelDialogContent,
        havePreferencesChanged: havePreferencesChanged,
        defaultDestinationBehavior: defaultDestinationBehavior,
        workspaceAddedNewDestinations: workspaceAddedNewDestinations,
        preferencesDialogTemplate: preferencesDialogTemplate ? _this.mergeTemplates(preferencesDialogTemplate, defaultPreferencesDialogTemplate) : ConsentManager.defaultProps.preferencesDialogTemplate
      });
    });
  };
  ConsentManager.displayName = 'ConsentManager';
  ConsentManager.defaultProps = {
    otherWriteKeys: [],
    shouldRequireConsent: function () {
      return true;
    },
    implyConsentOnInteraction: false,
    onError: undefined,
    cookieDomain: undefined,
    cookieName: undefined,
    cookieExpires: undefined,
    cookieAttributes: {},
    customCategories: undefined,
    bannerActionsBlock: undefined,
    bannerHideCloseButton: false,
    bannerTextColor: '#fff',
    bannerSubContent: 'You can change your preferences at any time.',
    bannerBackgroundColor: '#1f4160',
    preferencesDialogTitle: 'Website Data Collection Preferences',
    cancelDialogTitle: 'Are you sure you want to cancel?',
    defaultDestinationBehavior: 'disable',
    preferencesDialogTemplate: defaultPreferencesDialogTemplate
  };
  return ConsentManager;
}(PureComponent);
export default ConsentManager;